import { Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { homeGuard } from './core/guards/home.guard';
import { requestDetailGuard } from './core/guards/request-detail.guard';
import { CardRequestDetailComponent } from './main/home-cards/card-request-detail/card-request-detail.component';
import { CardRequestsComponent } from './main/home-cards/card-requests/card-requests.component';
import { HomeCardsComponent } from './main/home-cards/home-cards.component';
import { FreelancerAdministrationComponent } from './main/home-freelancers/freelancer-administration/freelancer-administration.component';
import { FreelancerRequestDetailComponent } from './main/home-freelancers/freelancer-request-detail/freelancer-request-detail.component';
import { RequestsComponent } from './main/home-freelancers/freelancer-requests/freelancer-requests.component';
import { HomeFreelancersComponent } from './main/home-freelancers/home-freelancers.component';
import { HomeInnovationComponent } from './main/home-innovation/home-innovation.component';
import { InnovationRequestDetailComponent } from './main/home-innovation/innovation-request-detail/innovation-request-detail.component';
import { InnovationRequestsComponent } from './main/home-innovation/innovation-requests/innovation-requests.component';
import { HomeStandardComponent } from './main/home-standard/home-standard.component';
import { StandardRequestDetailComponent } from './main/home-standard/standard-request-detail/standard-request-detail.component';
import { StandardRequestsComponent } from './main/home-standard/standard-requests/standard-requests.component';
import { LoginRedirectComponent } from './main/login/login-redirect/login-redirect.component';
import { LoginComponent } from './main/login/login.component';
import { SsoRedirectComponent } from './main/login/sso-redirect/sso-redirect.component';
import { Error401Component } from './shared/components/error-pages/error-401/error-401.component';
import { Error403Component } from './shared/components/error-pages/error-403/error-403.component';
import { Error404Component } from './shared/components/error-pages/error-404/error-404.component';
import { Error500Component } from './shared/components/error-pages/error-500/error-500.component';
import { JsonViewerComponent } from './utils/json-viewer/json-viewer.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'login/callback', component: OktaCallbackComponent },
    { path: 'login-redirect', component: LoginRedirectComponent },
    { path: 'sso-redirect', component: SsoRedirectComponent },
    // { path: 'sso-test', component: SsoTestComponent },
    {
        path: 'freelancers', component: HomeFreelancersComponent, canActivate: [homeGuard],
        children: [
            { path: 'requests', component: RequestsComponent },
            { path: 'request-detail/:id', component: FreelancerRequestDetailComponent, canActivate: [requestDetailGuard] },
            { path: 'administration', component: FreelancerAdministrationComponent },
            { path: '', redirectTo: 'requests', pathMatch: 'full' },
        ]
    },
    {
        path: 'cards', component: HomeCardsComponent, canActivate: [homeGuard],
        children: [
            { path: 'requests', component: CardRequestsComponent },
            { path: 'request-detail/:id', component: CardRequestDetailComponent, canActivate: [requestDetailGuard] },
            { path: '', redirectTo: 'requests', pathMatch: 'full' }
        ]
    },
    {
        path: 'standard', component: HomeStandardComponent, canActivate: [homeGuard],
        children: [
            { path: 'requests', component: StandardRequestsComponent },
            { path: 'request-detail/:id', component: StandardRequestDetailComponent, canActivate: [requestDetailGuard] },
            { path: '', redirectTo: 'requests', pathMatch: 'full' }
        ]
    },
    {
        path: 'innovation', component: HomeInnovationComponent, canActivate: [homeGuard],
        children: [
            { path: 'requests', component: InnovationRequestsComponent },
            { path: 'request-detail/:id', component: InnovationRequestDetailComponent, canActivate: [requestDetailGuard] },
            { path: '', redirectTo: 'requests', pathMatch: 'full' }
        ]
    },
    {
        path: 'error',
        children: [
            {
                path: '401',
                component: Error401Component
            },
            {
                path: '403',
                component: Error403Component
            },
            {
                path: '404',
                component: Error404Component
            },
            {
                path: '500',
                component: Error500Component
            },
            {
                path: '',
                redirectTo: '404',
                pathMatch: 'full'
            }
        ]
    },
    { path: 'json', component: JsonViewerComponent },

    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: '**', redirectTo: 'error' }
];
